export default __webpack_public_path__ + "offerCards.0b8a74506d662d0d1a372d4ff2821cd4.png";